import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

export const fetchProductCategories = async () => {
	try {
		const response = await ApiClient.GET('fetchSubCategory');
		const tmpCategories = [];
		for (let ctg of response.data) {
			for (let item of ctg.subCategoryResponseList) {
				tmpCategories.push({
					ctgId: ctg?.id,
					id: item.id,
					value: item.name,
					isPrimary: item.isPrimary,
					name: item?.name
				});
			}
		}
		return tmpCategories;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchBodyFabric = async (searchKey = '', bodyFabric) => {
	try {
		const response = await ApiClient.GET('getAllMaterialsBrief', {
			page: 0,
			size: 20,
			supplierType: 'FABRIC',
			search: searchKey,
			fabricType: bodyFabric
		});
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const updateDesignBasicInfo = async (body, productId) => {
	try {
		const response = await ApiClient.PUT('upDateDesign', body, productId);
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const updateCroppedImageOnSave = async (body, productId) => {
	try {
		const response = await ApiClient.POST('updateGroupDocument', { ...body }, productId);
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const deleteProductImage = async (designId, docId) => {
	try {
		const response = await ApiClient.DELETE('deleteProductDocument', {}, `${designId}/${docId}`);
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const uloadProductImage = async (body, designId) => {
	try {
		const response = await ApiClient.POST('uploadDocumentInProduct', body, designId);
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const updateBodyFabric = async (designId, materialId) => {
	try {
		const params = `${designId}/${materialId}?materialType=MAIN_FABRIC`;
		const response = await ApiClient.POST('addMaterialToProduct', {}, params);
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const replaceBodyFabric = async (designId, materialId, existingMaterialId) => {
	try {
		const params = `${designId}/${materialId}?existingMaterialId=${existingMaterialId}&materialType=MAIN_FABRIC`;
		const response = await ApiClient.POST('replaceMaterialFromProduct', {}, params);
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchDesignLooks = async () => {
	try {
		const response = await ApiClient.GET('designLooks');
		const looks = response?.data.map((item) => ({
			id: item?.constant,
			name: item?.name,
			value: item?.name
		}));
		return looks;
	} catch (error) {
		printApiError(error);
	}
};

export const fetchUsersListByRole = async (params) => {
	try {
		const { data } = await ApiClient.GET('getProjectUserSuggestions', params);
		const response = data?.map((item) => ({
			...item,
			value: item?.nickName
		}));
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const getProductSamples = async (productId, source) => {
	try {
		const params = `?productIds=${productId}&source=${source}`;
		const { data } = await ApiClient.GET('productSampleInventory', params);
		return data;
	} catch {
		printApiError();
	}
};

export const getProductSampleLocations = async (params) => {
	try {
		const { data } = await ApiClient.GET('productLocations', params);

		if (data?.data?.length > 0) {
			const locations = data?.data?.map((item) => ({
				...item,
				value: item?.locationId
			}));
			return locations;
		}
	} catch (error) {
		printApiError(error);
	}
};

export const getSampleCountryList = async () => {
	try {
		const { data = [] } = await ApiClient.GET('getCountryList');

		const countryList = data?.map((country) => ({
			id: country?.id,
			name: country?.code,
			value: country?.code,
			code: country?.code
		}));
		return countryList;
	} catch (error) {
		printApiError(error);
	}
};

export const submitSampleUpdate = async (requestBody) => {
	try {
		const { data } = await ApiClient.POST('addNewSampleInventory', requestBody);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const addNewLocation = async (requestBody) => {
	try {
		const { data } = await ApiClient.POST('productLocationsAdd', requestBody);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const editLocation = async (requestBody, locationId) => {
	try {
		const { data } = await ApiClient.PUT('productLocationsEdit', requestBody, locationId);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateSampelInventory = async (sampleId, isWrongEntry) => {
	try {
		const params = `${sampleId}?isWrongEntry=${isWrongEntry}`;
		const response = await ApiClient.PUT('updateSampleInventory', {}, params);
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const getAllSuppliers = async (param) => {
	try {
		const response = await ApiClient.GET('supplierDependentFilterList', param);
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const getAllLocationsTag = async (param) => {
	try {
		const { data } = await ApiClient.GET('locationsTag', param);
		const response = data?.map((item) => ({
			...item,
			value: item?.text
		}));
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const getLocationById = async (id) => {
	try {
		const { data } = await ApiClient.GET('singleLocation', id);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
